import styled from "styled-components";

export const Styles = styled.div`
  .ant-input,
  .ant-input-affix-wrapper > input.ant-input,
  .ant-picker-input > input {
    font-size: 16px;
  }

  &.timeline-text {
    white-space: pre-line;
  }

  &.timeline-text .ant-form-item {
    margin-bottom: 0;
    width: 100%;
  }

  &.timeline-time .ant-form-item {
    margin-bottom: 0;
  }

  &.timeline-text-readonly,
  &.timeline-time-readonly {
    .readonly-line {
      display: inline-block;
      min-height: 22px;
      font-size: 15px;
      font-weight: 600;
      color: var(--color-item);
    }
  }

  .mobile & {
    &.timeline-time-readonly .readonly-line {
      color: #ccc;
    }
  }

  &.timeline-location {
    display: flex;
    gap: 6px;
    align-items: center;
    color: var(--color-item);
  }

  .location-text {
    color: var(--color-item);
    font-size: 13px;

    a {
      color: #5392f0;
    }
  }

  &.timeline-attachments {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-top: 4px;
    min-width: 0;
    width: 100%;
  }

  .thumb-wrap {
    position: relative;
    padding: 4px 7px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: visible;
  }

  .thumb-remove {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    border: none;
    border-radius: 0 4px 0 6px;
    background: rgba(220, 53, 69, 0.95);
    color: #fff;
    cursor: pointer;
    line-height: 1;
    z-index: 2;
  }

  .thumb-remove:hover {
    background: #c82333;
  }

  .timeline-attachments-form-item .ant-form-item-control-input {
    min-height: 0;
  }

  .timeline-attachments-form-item .ant-form-item-control-input-content {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    min-width: 0;
    width: 100%;
  }

  .add-image-placeholder {
    min-width: 50px;
    min-height: 50px;
    border: 1px dashed #00000026;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-size: 10px;
    color: #5392f0;
    padding: 4px;
    text-align: center;
    cursor: pointer;
    background: transparent;
    position: relative;

    .mobile & {
      border-color: #f5f5f5;
    }
  }

  .add-image-placeholder:hover {
    border-color: #5392f0;
    color: #5392f0;
  }

  .add-image-icon {
    font-size: 18px;
    color: #5392f0;
  }

  .add-image-plus {
    position: absolute;
    padding: 2px;
    font-size: 10px;
    top: 1px;
    left: 9px;
    color: #fff;
    background: #5392f0;
    border-radius: 50%;
  }
`;
